export { EDITOR_TYPE, HandsontableEditor } from "./handsontableEditor.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/editors/handsontableEditor/index.mjs
// module id = 314
// module chunks = 1